import { components } from "@certn/api/generated-schemas/applicant-portal";
import { formatDate } from "@certn/utils";
import { useTranslation } from "react-i18next";

import { BaseCard } from "./BaseCard";

interface Props {
  caseInstance: components["schemas"]["CompleteCaseList"];
}

export function ArchivedCard(props: Props) {
  const { caseInstance } = props;
  const { t } = useTranslation();

  // Don't show the "Expired" text if we don't get a valid date
  const statusTextDate = formatDate(
    caseInstance.expires_on ?? caseInstance.archived_on ?? "",
    "PP",
    undefined
  );

  return (
    <BaseCard
      title={caseInstance.customer_name}
      type="archived"
      tagText={t("Archived")}
      statusText={statusTextDate && `${t("Expired")} ${statusTextDate}`}
      variant="historyCard"
      shortID={caseInstance.short_id}
    />
  );
}
